const TYPES = require('reducers/personalizedPromotions').ACTION_TYPES;
const ProfileApi = require('services/api/profile');
const UserUtils = require('utils/User');
const Storage = require('utils/localStorage/Storage');
const LOCAL_STORAGE = require('utils/localStorage/Constants');
const PERSONALIZED_PROMOTIONS_DATA_EXPIRY = Storage.HOURS * 1;

const updatePersonalizedPromotions = data => ({
    type: TYPES.UPDATE_PERSONALIZED_PROMOTIONS,
    data: data
});

const createEmptyPayload = profileId => ({
    profileId: profileId,
    items: [],
    loading: false
});

const loadPersonalizedPromotions = () => (dispatch, getState) => {
    const {
        user, user: { profileId }, personalizedPromotions
    } = getState();
    if (personalizedPromotions.loading) {
        return;
    }

    const payload = createEmptyPayload();
    payload.loading = true;
    dispatch(updatePersonalizedPromotions(payload));

    const cachedPromotions = Storage.local.getItem(LOCAL_STORAGE.PERSONALIZED_PROMOTIONS, false, true);

    if (UserUtils.isAnonymous(user)) {
        dispatch(updatePersonalizedPromotions(createEmptyPayload()));
    } else if (cachedPromotions && cachedPromotions.profileId === profileId) {
        dispatch(updatePersonalizedPromotions(cachedPromotions));
    } else {
        ProfileApi.getPersonalizedPromotions().then(data => {
            const freshData = {
                profileId,
                items: data.personalizedPromotions || [],
                loading: false,
                hasNewPersonalizedPromotions: false
            };
            const userData = Storage.local.getItem(LOCAL_STORAGE.USER_DATA, false, false, true);
            if (userData?.data?.personalizedPromotions?.hasNewPersonalizedPromotions) {
                userData.data.personalizedPromotions.hasNewPersonalizedPromotions = false;
                Storage.local.setItem(LOCAL_STORAGE.USER_DATA, userData.data, userData.expiry);
            }
            Storage.local.setItem(LOCAL_STORAGE.PERSONALIZED_PROMOTIONS, freshData, PERSONALIZED_PROMOTIONS_DATA_EXPIRY);
            dispatch(updatePersonalizedPromotions(freshData));
        }).catch((error) => {
            // eslint-disable-next-line no-console
            console.error(error);
            dispatch(updatePersonalizedPromotions(createEmptyPayload(profileId)));
        });
    }
};


module.exports = {
    TYPES,
    loadPersonalizedPromotions,
    updatePersonalizedPromotions
};
